function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.901367 22.5218C0.901367 34.624 10.7122 44.4348 22.8144 44.4348C34.9166 44.4348 44.7275 34.624 44.7275 22.5218C44.7275 10.4196 34.9166 0.608765 22.8144 0.608765C10.7122 0.608765 0.901367 10.4196 0.901367 22.5218ZM40.7431 22.5219C40.7431 32.4237 32.7161 40.4507 22.8143 40.4507C12.9124 40.4507 4.88543 32.4237 4.88543 22.5219C4.88543 12.62 12.9124 4.59302 22.8143 4.59302C32.7161 4.59302 40.7431 12.62 40.7431 22.5219ZM22.8149 34.471C23.9154 34.471 24.8076 33.5791 24.8076 32.4789C24.8076 31.3787 23.9154 30.4868 22.8149 30.4868C21.7143 30.4868 20.8221 31.3787 20.8221 32.4789C20.8221 33.5791 21.7143 34.471 22.8149 34.471ZM24.8135 10.566H20.828V26.5028H24.8135V10.566Z",
  fill: "white"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.0fcf0938.svg";
export { ForwardRef as ReactComponent };